import { render, staticRenderFns } from "./ConnectionShippingAccount.vue?vue&type=template&id=4ac3e48f"
import script from "./ConnectionShippingAccount.vue?vue&type=script&lang=js"
export * from "./ConnectionShippingAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports